import React from 'react';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack } from '@/Components/ui/layout';

function TopicHeader() {
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <Stack spacing="md" className="items-center text-center">
        <Heading level="h1" size="2xl" className="font-medium">
          Enter Interview Topic
        </Heading>
        <Text size="base" className="text-muted-foreground mt-5">
          Fusce commodo, sem non tempor convallis, sapien turpis bibendum turpis, non
        </Text>
      </Stack>
    </div>
  );
}

export default TopicHeader;